/* Craftly BOGO 2+1 cart progress bar + Subscription Discount Auto-Removal */

// === Subscription Discount Auto-Removal ===
// If the cart still carries the subscription code (MNUI_SUB_20) but the hidden club
// is gone, drop that code (other codes stay) and re-render the cart so the customer
// sees the full price. Only the MNUI code counts: the automatic 2+1 discount also
// shows up as a discount, and treating it as ours used to re-trigger this endlessly.
(function watchSubscriptionDiscount(){
  if (window.__craftlySubWatch) return;
  window.__craftlySubWatch = true;

  var HIDDEN_CLUB = 8028290777187;
  var RELOAD_KEY = 'craftlySubCodeCleared';
  var busy = false;

  // The join flow applies the code through /discount/MNUI_SUB_20, which also stores it
  // in the `discount_code` cookie. Checkout reads that cookie, so removing the code from
  // the cart alone still let a cart without the subscription get 20% off at checkout.
  // Only an MNUI code is touched; any other code the shopper used stays.
  function clearSubCookie(){
    try {
      var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
      if (!m || decodeURIComponent(m[1]).toUpperCase().indexOf('MNUI') < 0) return;
      var host = location.hostname.replace(/^www\./, '');
      ['', '; domain=' + host, '; domain=.' + host].forEach(function(d){
        document.cookie = 'discount_code=; Max-Age=0; path=/' + d;
      });
    } catch(e){}
  }
  window.craftlyClearSubCookie = clearSubCookie;

  function isCartPage(){ var tv = window.themeVariables; return !!(tv && tv.settings && tv.settings.pageType === 'cart'); }

  function checkClubRemoval(){
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var hasClub = (cart.items || []).some(function(it){ return it.product_id === HIDDEN_CLUB; });
        var codes = cart.discount_codes || [];
        var isSub = function(d){ return (d.code || '').indexOf('MNUI') >= 0; };
        if (!hasClub) clearSubCookie();
        if (hasClub || !codes.some(isSub)) return;
        var onCartPage = isCartPage();
        if (onCartPage) {
          try { if (sessionStorage.getItem(RELOAD_KEY) === '1') return; } catch(e){}
        }
        var keep = codes.filter(function(d){ return !isSub(d); }).map(function(d){ return d.code; }).join(',');
        var body = { discount: keep };
        if (!onCartPage) body.sections = ['mini-cart'];
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function(r){ return r.json(); }).then(function(updated){
          if (onCartPage) {
            try { sessionStorage.setItem(RELOAD_KEY, '1'); } catch(e){}
            window.location.replace('/cart');
            return;
          }
          // The theme listens on <html>; this re-renders the drawer with full prices.
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: updated } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: updated } }));
        });
      })
      .catch(function(){})
      .then(function(){ busy = false; });
  }

  ['cart:refresh','cart:item-removed','cart:updated','cart:build','on:cart:updated','cart:item-added'].forEach(function(name){
    document.addEventListener(name, function(){ setTimeout(checkClubRemoval, 350); });
  });

  function onLoad(){
    try { if (sessionStorage.getItem(RELOAD_KEY) === '1') { sessionStorage.removeItem(RELOAD_KEY); return; } } catch(e){}
    checkClubRemoval();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onLoad, { once: true });
  else onLoad();
})();

(function(){
  if (window.customElements && window.customElements.get('craftly-bogo-bar')) return;

  class CraftlyBogoBar extends HTMLElement {
    connectedCallback(){
      if (this._init) return;
      // This script loads in <head>, so on a full page (the cart page) the element
      // is upgraded before its children are parsed. Wait for them, or it never renders.
      if (!this.querySelector('[data-cbb-card]')) {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.connectedCallback.bind(this), { once: true });
        }
        return;
      }
      this._init = true;
      this.card = this.querySelector('[data-cbb-card]');
      this.msgEl = this.querySelector('[data-cbb-msg]');
      this.iconEl = this.querySelector('[data-cbb-icon]');
      this.fillEl = this.querySelector('[data-cbb-fill]');
      this.statsEl = this.querySelector('[data-cbb-stats]');
      if (!this.card || !this.msgEl || !this.fillEl) return;
      this.excludedProducts = (this.dataset.excludedProducts || '').split(',')
        .map(function(s){ return parseInt(s, 10); })
        .filter(function(n){ return !isNaN(n); });
      this.eligibleProducts = (this.dataset.eligibleProducts || '').split(',')
        .map(function(s){ return parseInt(s, 10); })
        .filter(function(n){ return !isNaN(n); });
      this.ineligibleProducts = (this.dataset.ineligibleProducts || '').split(',')
        .map(function(s){ return parseInt(s, 10); })
        .filter(function(n){ return !isNaN(n); });
      this.render(parseInt(this.dataset.count, 10) || 0);
      this._onUpdate = this.refreshFromAPI.bind(this);
      var ev = ['cart:refresh','cart:item-added','on:cart:added','cart:build','cart:updated','product:added'];
      var self = this;
      ev.forEach(function(n){ document.addEventListener(n, self._onUpdate); });
      // Also refresh after a tick in case the drawer was just re-rendered with stale count
      setTimeout(this._onUpdate, 50);
    }
    disconnectedCallback(){
      if (!this._onUpdate) return;
      var self = this;
      ['cart:refresh','cart:item-added','on:cart:added','cart:build','cart:updated','product:added']
        .forEach(function(n){ document.removeEventListener(n, self._onUpdate); });
    }
    computeFromCart(cart){
      var count = 0;
      var ex = this.excludedProducts;
      var inel = this.ineligibleProducts || [];
      (cart.items || []).forEach(function(it){
        if (ex.indexOf(it.product_id) >= 0) return;
        if (it.selling_plan_allocation) return;
        // Liquid lists the cart products that are NOT in the 2+1 discount
        // (outside its collections, accessories, no-bogo tags). Skip those.
        // (The old check used the eligible list, which counted everything
        // whenever the cart held no eligible product at all.)
        if (inel.indexOf(it.product_id) >= 0) return;
        count += it.quantity;
      });
      return count;
    }
    refreshFromAPI(){
      var self = this;
      fetch('/cart.js')
        .then(function(r){ return r.json(); })
        .then(function(cart){ self.render(self.computeFromCart(cart)); })
        .catch(function(){});
    }
    render(count){
      if (count <= 0){
        this.hidden = true;
        this.dataset.count = '0';
        return;
      }
      this.hidden = false;
      this.dataset.count = count;

      var inCycle = count % 3;
      var completed = Math.floor(count / 3);
      var msg = '', pct = 0, icon = '🎁', isComplete = false, stats = '';

      if (inCycle === 0){
        msg = '✓ <strong>מבצע 2+1 חל!</strong> ' + (completed === 1 ? 'הפריט הזול חינם' : completed + ' פריטים חינם') + ' - ההנחה תרד בקופה.';
        pct = 100; icon = '🎉'; isComplete = true;
        stats = 'הוסיפו עוד 3 פריטים משתתפים לעוד אחד חינם';
      } else if (inCycle === 2){
        msg = 'עוד פריט <strong>אחד</strong> והשלישי <strong>חינם</strong>!';
        pct = 66.6; icon = '✨';
        stats = completed > 0
          ? (completed + ' חינם בקופה • עוד פריט אחד לעוד הנחה')
          : (count + ' פריטים במבצע • עוד אחד וההנחה חלה');
      } else if (inCycle === 1){
        msg = 'הוסיפו עוד <strong>2 פריטים</strong> והשלישי <strong>חינם</strong>!';
        pct = 33.3; icon = '🎁';
        stats = completed > 0
          ? (completed + ' חינם בקופה • עוד 2 לעוד הנחה')
          : (count + ' פריטים במבצע • עוד 2 וההנחה חלה');
      }

      this.msgEl.innerHTML = msg;
      this.fillEl.style.width = pct + '%';
      this.iconEl.textContent = icon;
      this.statsEl.textContent = stats;
      this.card.classList.toggle('is-complete', isComplete);
    }
  }

  customElements.define('craftly-bogo-bar', CraftlyBogoBar);
})();

// === Subscription follows its product ===
// "רכשו כמנוי" adds the product (property "מצורף למנוי") together with the hidden
// club product. If the customer removes that product, the club goes with it.
// Removals are intercepted before the theme runs them, so the product and the club
// leave in ONE request and the cart re-renders once (no flash of a lone club).
// A safety net also cleans up a lone club reached any other way.
(function clubFollowsProduct(){
  if (window.__craftlyClubLink) return;
  window.__craftlyClubLink = true;

  var HIDDEN_CLUB = 8028290777187;
  var HIDDEN_CLUB_VARIANT = 44237944815715;   // its only variant
  var LINK_PROP = 'מצורף למנוי';
  var NOTICE_KEY = 'craftlyClubRemovedNotice';
  var SWEEP_KEY = 'craftlyClubSweep';
  var knownCart = null;   // last cart seen; lets ordinary carts skip all of this

  function isClub(it){ return it.product_id === HIDDEN_CLUB; }
  function isLinked(it){ return !!(it.properties && it.properties[LINK_PROP]); }
  function hasClub(cart){ return !!(cart && (cart.items || []).some(isClub)); }
  function isCartPage(){ var tv = window.themeVariables; return !!(tv && tv.settings && tv.settings.pageType === 'cart'); }
  function getCart(){ return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function(r){ return r.json(); }); }

  // Clubs left without any linked product once `removedKey` is gone (null = nothing removed).
  function orphanClubs(cart, removedKey){
    var clubs = cart.items.filter(isClub);
    if (!clubs.length) return [];
    var linkedLeft = cart.items.some(function(it){ return it.key !== removedKey && isLinked(it); });
    return linkedLeft ? [] : clubs;
  }

  function showNotice(){
    var el = document.createElement('div');
    el.setAttribute('role', 'status');
    el.dir = 'rtl';
    el.textContent = 'המנוי הוסר יחד עם הערכה';
    el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translate(-50%,12px);z-index:2147483000;background:#26362D;color:#fff;font-family:inherit;font-size:14px;font-weight:700;line-height:1.4;padding:11px 18px;border-radius:999px;box-shadow:0 8px 24px rgba(0,0,0,.18);opacity:0;transition:opacity .25s ease,transform .25s ease;pointer-events:none;white-space:nowrap';
    document.body.appendChild(el);
    requestAnimationFrame(function(){ el.style.opacity = '1'; el.style.transform = 'translate(-50%,0)'; });
    setTimeout(function(){ el.style.opacity = '0'; el.style.transform = 'translate(-50%,12px)'; }, 2800);
    setTimeout(function(){ if (el.parentNode) el.parentNode.removeChild(el); }, 3200);
  }

  // Tell the theme the cart changed, exactly the way its own quantity control does.
  function announce(cart, lineQty){
    if (lineQty) lineQty.dispatchEvent(new CustomEvent('line-item-quantity:change:end', { bubbles: true, detail: { cart: cart, newLineQuantity: 0 } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, replacementDelay: 600 } }));
  }

  // Remove `keys` in one request. If no club is left, the subscription code goes in the
  // same request, so prices are right on the first render. On the cart page reload once;
  // in the drawer re-render in place.
  function removeKeys(keys, lineQty, cart, notice){
    var updates = {};
    keys.forEach(function(k){ updates[k] = 0; });
    var body = { updates: updates };
    var clubLeft = cart.items.some(function(it){ return isClub(it) && keys.indexOf(it.key) === -1; });
    var codes = cart.discount_codes || [];
    var isSub = function(d){ return (d.code || '').indexOf('MNUI') >= 0; };
    if (!clubLeft && window.craftlyClearSubCookie) window.craftlyClearSubCookie();
    if (!clubLeft && codes.some(isSub)) {
      body.discount = codes.filter(function(d){ return !isSub(d); }).map(function(d){ return d.code; }).join(',');
    }
    var onCartPage = isCartPage();
    if (!onCartPage) body.sections = ['mini-cart'];
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r){
      if (!r.ok) throw new Error('update failed');
      return r.json();
    }).then(function(cart){
      knownCart = cart;
      if (onCartPage) {
        try { if (notice) sessionStorage.setItem(NOTICE_KEY, '1'); } catch(e){}
        window.location.replace('/cart');
        return;
      }
      announce(cart, lineQty);
      if (notice) showNotice();
    });
  }

  function parseChange(href){
    try {
      var u = new URL(href, window.location.origin);
      if (!/\/cart\/change/.test(u.pathname)) return null;
      return { line: u.searchParams.get('line'), id: u.searchParams.get('id'), quantity: parseInt(u.searchParams.get('quantity'), 10) };
    } catch(e){ return null; }
  }

  function lineOf(cart, req){
    if (req.id) {
      return cart.items.find(function(it){ return it.key === req.id; })
          || cart.items.find(function(it){ return String(it.variant_id) === String(req.id); });
    }
    var n = parseInt(req.line, 10);
    return n ? cart.items[n - 1] : null;
  }

  // Hand the removal back to the theme untouched.
  function passThrough(lineQty, href){
    if (lineQty && typeof lineQty._updateFromLink === 'function') { lineQty._updateFromLink(href); return; }
    window.location.href = href;
  }

  function intercept(e, lineQty, href){
    var req = parseChange(href);
    if (!req || req.quantity !== 0) return;          // only full removals matter
    // Ordinary cart (no subscription line on screen): the theme handles it as always.
    // Read from the DOM, not a remembered cart: the join flow adds lines without telling us.
    if (!document.querySelector('a[href*="/cart/change"][href*="' + HIDDEN_CLUB_VARIANT + ':"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    // Show the theme's loader right away, while we look at the cart.
    if (lineQty) lineQty.dispatchEvent(new CustomEvent('line-item-quantity:change:start', { bubbles: true, detail: { newLineQuantity: 0 } }));
    getCart().then(function(cart){
      knownCart = cart;
      var target = lineOf(cart, req);
      if (!target) { passThrough(lineQty, href); return; }
      if (isClub(target)) {
        // Removing the subscription itself: its code leaves too, the product stays at full price.
        return removeKeys([target.key], lineQty, cart, false);
      }
      var clubs = isLinked(target) ? orphanClubs(cart, target.key) : [];
      if (!clubs.length) { passThrough(lineQty, href); return; }
      return removeKeys([target.key].concat(clubs.map(function(c){ return c.key; })), lineQty, cart, true);
    }).catch(function(){ passThrough(lineQty, href); });
  }

  // Remove buttons, and the "-" button when it would reach 0
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest && e.target.closest('line-item-quantity a[href]');
    if (!a) return;
    intercept(e, a.closest('line-item-quantity'), a.getAttribute('href'));
  }, true);

  // Typing 0 into the quantity box
  document.addEventListener('change', function(e){
    var inp = e.target;
    if (!inp || !inp.closest || inp.name !== 'updates[]' || !inp.closest('line-item-quantity')) return;
    if (parseInt(inp.value, 10) !== 0) return;
    var tv = window.themeVariables;
    var base = (tv && tv.routes && tv.routes.cartChangeUrl) || '/cart/change';
    intercept(e, inp.closest('line-item-quantity'), base + '?quantity=0&line=' + inp.getAttribute('data-line'));
  }, true);

  // Safety net: a lone club reached any other way is removed quietly.
  var cleaning = false;
  function sweep(cart){
    knownCart = cart;
    if (cleaning || !hasClub(cart)) return;
    var clubs = orphanClubs(cart, null);
    if (!clubs.length) return;
    if (isCartPage()) {
      // never loop reloads if the removal keeps failing
      try { if (sessionStorage.getItem(SWEEP_KEY) === '1') return; sessionStorage.setItem(SWEEP_KEY, '1'); } catch(e){}
    }
    cleaning = true;
    removeKeys(clubs.map(function(c){ return c.key; }), null, cart, true)
      .catch(function(){})
      .then(function(){ cleaning = false; });
  }

  function start(){
    var notice = false;
    try {
      notice = sessionStorage.getItem(NOTICE_KEY) === '1';
      sessionStorage.removeItem(NOTICE_KEY);
      if (!notice) sessionStorage.removeItem(SWEEP_KEY);
    } catch(e){}
    if (notice) showNotice();
    getCart().then(sweep).catch(function(){});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  document.documentElement.addEventListener('cart:updated', function(e){
    if (!(e.detail && e.detail.cart && e.detail.cart.items)) return;
    knownCart = e.detail.cart;
    // Give add-to-cart flows a moment to finish before judging.
    setTimeout(function(){ getCart().then(sweep).catch(function(){}); }, 400);
  });
})();
